import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const inspirationProductGalleryTrioSchema = Joi.object({
  type: Joi.string().valid('inspirationProductGalleryTrio').required(),
  code: Joi.string().allow('', null).required(),
  variant: Joi.string().allow('', null).required(),
  background: Joi.string().allow('', null).required(),
  images: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    image: mediaUrlSchema.required(),
    imageWithBlur: imagesWithBlurSchema.allow('', null),
    imageHover: Joi.alternatives().try(Joi.string(), Joi.object(imageWithMetaDataSchema)).allow(null, ''),
    products: Joi.array().items(Joi.object().unknown(true)),
    productBottom: Joi.array().items(Joi.object().unknown(true)),
    variant: Joi.string().allow('', null).required()
  }).unknown(true))
}).unknown(true);
export default inspirationProductGalleryTrioSchema;